import { showCustomImage } from 'globalCommon/utils/index';
import commonPageService from 'pcCommon/services/commonPageService';
import { syncRender } from 'globalCommon/services/syncRender';
import { UserLogoMap } from '../common/utils/imageSource';
import './style.css';

function init() {
    showCustomImage(UserLogoMap, 'customer-img');
    commonPageService({ renderAfter: syncRender });
}

init();
